
"use strict"; // jshint ignore:line

import { BaseAdditionalObject } from './base-additional-object.js';
import { AdditionalObjectJSON  } from './additional-object-json.js';
import { AdditionalObjectCube  } from './additional-object-cube.js';
import { AdditionalObjectPlane } from './additional-object-plane.js';
import { AdditionalObjectLight } from './additional-object-light.js';
import { AdditionalObjectText  } from './additional-object-text.js';

export function injector() {

	BaseAdditionalObject.JSON  = AdditionalObjectJSON;
	BaseAdditionalObject.Light = AdditionalObjectLight;
	BaseAdditionalObject.Cube  = AdditionalObjectCube;
	BaseAdditionalObject.Plane = AdditionalObjectPlane;
	BaseAdditionalObject.Text  = AdditionalObjectText;

	return BaseAdditionalObject;
};
